<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.handerType" placeholder="请选择处理状态" size="small">
                        <el-option value="" label="不限制状态"></el-option>
                        <el-option :value="1" label="仅看未回复的"></el-option>
                        <el-option :value="2" label="仅看已回复的"></el-option>
                    </el-select>
                </el-col>
                  <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" >                   
					<el-date-picker
						  size="small"
					      v-model="params.fbBeginTime"
					      type="datetime"
					      placeholder="反馈开始日期">
					    </el-date-picker>
                </el-col>
				<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" >
					<el-date-picker
						 size="small"
					      v-model="params.fbEndTime"
					      type="datetime"
					      placeholder="反馈结束日期">
					    </el-date-picker>
				</el-col>
                <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="$utils.have('/suggest/export')" class="page-btns-box">
            <el-button
                type="primary"
                icon="el-icon-download"
                @click="download"
                size="small"
                :loading="downLoading"
                >导出反馈</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column label="状态" width="80">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.isHandle == 1" size="mini" type="danger">未回复</el-tag>
                        <el-tag v-else size="mini" type="success">已回复</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="图片" width="50">
                    <template slot-scope="scope">
                        <span v-if="scope.row.screenshot ">有</span>
                        <span v-else >无</span>
                    </template>
                </el-table-column>
                <el-table-column label="问题描述" min-width="200" show-overflow-tooltip>
                    <el-link class="ellipsis" slot-scope="scope" @click="view(scope.row)">
                        {{ scope.row.content }}
                    </el-link>
                </el-table-column>
				 <el-table-column label="反馈人(用户ID/用户名/手机号)" min-width="200" show-overflow-tooltip>
					  <template slot-scope="scope">
						{{ scope.row.createUser }}<span class="line">/</span>{{ scope.row.userName }}<span class="line">/</span>{{ scope.row.areaCode && scope.row.areaCode != '86_CN' ? '+'+scope.row.areaCode.split('_')[0] : '' }}{{ scope.row.contact }}
					 </template>
				 </el-table-column>
                <el-table-column label="设备信息(APP版本/手机系统)" min-width="170">
					<template slot-scope="scope">
						{{ scope.row.version }}<span class="line">/</span>{{ scope.row.os }}
					 </template>
				</el-table-column>
                <el-table-column prop="createTime" label="反馈时间" min-width="100"></el-table-column>
                <el-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            icon="el-icon-view"
                            @click="view(scope.row)"
                            >管理</el-button>
                        <!-- <template v-if="$utils.have('/suggest/updateHanderType')">    
                            <el-button
                                v-if="scope.row.isHandle == 1"
                                type="text"
                                size="small"
                                icon="el-icon-finished"
                                @click="updateHanderEvent(scope.row)"
                                >标记为已处理</el-button>
                            <el-button
                                v-else
                                type="text"
                                size="small"
                                icon="el-icon-refresh-left"
                                @click="updateHanderEvent(scope.row)"
                                >标记为未处理</el-button>
                        </template> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0"
            >
            </el-pagination>
        </div>
        <suggest-details :data-detail="suggestData" ref="suggestDetails" @onUpdate="getDataList"></suggest-details>
    </div>
</template>
<script>
import SuggestDetails from './components/suggest-details';
import {downloadFileTmp} from '@/assets/js/commonApi.js';
const defaultParams = {
    pageNo: 1,
    handerType:'',
    fbBeginTime:'',
    fbEndTime:''
}
export default {
    components:{SuggestDetails},
    data() {
        return {
            data: null,
            dataList: null,
           // daterange: [this.$route.query.fbBeginTime || '', this.$route.query.fbEndTime || ''],
            params: {
                ...defaultParams,
                pageSize: this.$pageSizes[0],
                handerType: this.$route.query.handerType || ''
            },
            listLoading: true,
            suggestData: null,
            downLoading:false
        };
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
                // fbBeginTime: this.daterange ? this.daterange[0] : '',
                // fbEndTime: this.daterange ? this.daterange[1] : '',
                handerType: this.params.handerType == 0 ? '' : this.params.handerType
            }
            this.$request({
                url: "/suggest/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.daterange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //查看
        view(data) {
            this.suggestData = data;
            this.$refs.suggestDetails.show();
        },
        // //标记状态
        // updateHanderEvent(data){
        //     const status = data.isHandle == 1 ? 2 : 1;
        //     const _msg = status == 1 ? '确定要标记为未处理吗?' : '确定要标记为已处理吗？';
        //     this.$confirm(_msg, '提示', {
        //         type: 'warning',
        //         center: true,
        //         closeOnClickModal: false
        //     }).then(() => {
        //         this.listLoading = true;
        //         this.$request({
        //             url: "/suggest/updateHanderType",
        //             method: "POST",
        //             params: {id: data.id , isHandle: status},
        //         })
        //             .then((res) => {
        //                 const { state, msg } = res.data;
        //                 if (state == 1) {
        //                     this.$refs.suggestDetails.close();
        //                     this.getDataList();
        //                 } else {
        //                     this.$message.error(msg || "请求失败");
        //                 }
        //             })
        //             .catch(() => {
        //                 this.$message.error("请求错误");
        //             })
        //     }).catch(() => {})
        // },
        //导出反馈
        async download(){
            // const url = getHttp('/suggest/export',{searchParm:this.params});
            // this.$utils.downLoadReport(url);
            let filePath;
            this.downLoading = true;
            const res = await this.$request({
                url:'/suggest/export',
                method: 'post',
                params:{searchParam: JSON.stringify(this.params)}
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg,result} = res.data;
            if(state == 1 && result){
                filePath = result.url;
            }else{
                this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }   

            await downloadFileTmp(filePath,'意见反馈.xlsx');
            this.downLoading = false;
        }
    },
};
</script>

<style lang="scss" scoped>
.ellipsis{
    max-width:100%;
}
.line{
	color:#1FBB7D;
	padding:0 3px;
	font-weight: bold;
}
</style>